import React from 'react'

export default function NotificationNoItemIcon() {
    return (
        <svg width="68" height="39" viewBox="0 0 68 39" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.4" d="M49.6009 5.71883C50.6803 4.63932 50.6803 2.88913 49.6009 1.80961C48.5214 0.730129 46.7711 0.730129 45.6917 1.80961L16.3289 31.1723L5.71884 20.5624C4.63932 19.483 2.88912 19.483 1.80962 20.5624C0.730126 21.6418 0.730126 23.3922 1.80962 24.4716L14.3743 37.0361C15.4538 38.1158 17.204 38.1158 18.2835 37.0361L49.6009 5.71883Z" fill="#292D32" stroke="#292D32" strokeWidth="0.5" />
            <path d="M66.1904 5.71883C67.2698 4.63932 67.2698 2.88913 66.1904 1.80961C65.1107 0.730129 63.3607 0.730129 62.281 1.80961L30.9637 33.1269C29.8843 34.2066 29.8843 35.9567 30.9637 37.0361C32.0431 38.1158 33.7934 38.1158 34.8729 37.0361L66.1904 5.71883Z" fill="#292D32" stroke="#292D32" strokeWidth="0.5" />
        </svg>
    )
}
